<template>
    <div class="main">
        <info>
            <loader v-if="isLoading"></loader>
            <html-with-links :html="content.text"></html-with-links>
        </info>
    </div>
</template>

<script>
import Info from '@/components/Info';
import HtmlWithLinks from '@/components/HtmlWithLinks';
import Loader from '@/components/Loader';

export default {
  components: { Info, HtmlWithLinks, Loader },
  data() {
    return {
      isLoading: true,
      content: '',
    };
  },
  computed: {
    title() {
      return this.content.title;
    },
    id() {
      return this.$route.params.id;
    },
  },
  watch: {
    id() {
      this.getInfo();
    },
  },
  methods: {
    getInfo() {
      if (!+this.id) {
        this.$router.push({ name: 404 });
        return null;
      }
      this.isLoading = true;
      return this.$api.getArticle(this.id).then((response) => {
        this.content = response;
      })
        .catch(() => {
          this.$router.push({ name: 404 });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  serverPrefetch() {
    return this.getInfo();
  },
  created() {
    this.getInfo();
  },
};
</script>
